/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";

/* Component imports */

/* Style imports */
import "./styles.css";
/*** End Imports ***/

const OverlayTrans = (props) => {

    return (
        <div className="overlay-trans">
        </div>
    );
};

export default OverlayTrans;


// WEBPACK FOOTER //
// ./src/components/core/OverlayTrans/OverlayTrans.js


// WEBPACK FOOTER //
// ./src/components/core/OverlayTrans/OverlayTrans.js